/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FastFolderEntryInfo } from '../../models/fast-folder-entry-info';

export interface FolderControllerFastListFolderContent$Params {
  folderId: string;
}

export function folderControllerFastListFolderContent(http: HttpClient, rootUrl: string, params: FolderControllerFastListFolderContent$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FastFolderEntryInfo>>> {
  const rb = new RequestBuilder(rootUrl, folderControllerFastListFolderContent.PATH, 'get');
  if (params) {
    rb.path('folderId', params.folderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FastFolderEntryInfo>>;
    })
  );
}

folderControllerFastListFolderContent.PATH = '/folder/listFast/{folderId}';
